// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"493":"c11b28c1","738":"f610ca05"}[chunkId] + ".chunk.js";
};